import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Row, Col, Button, Checkbox, Modal, notification, Spin } from 'antd';
import { unexpectedError, components } from '../../../common_functions';
const CollectionsPermissions = props => {
  const { section, id } = useParams();
  const [collPermissions, setCollPermissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [permissionData, setpermissionData] = useState([]);
  const [isDisabled, setDisabled] = useState(true);
  //Get collection data
  useEffect(() => {
    (async () => {
    props.tabActiveKey == '1' && (await getColData());
  })();
  }, [props.tabActiveKey]);

  const getColData = async () => {
    try {
      setLoading(true);
      let { data } = await props.getItems('users_permissions', {
        fields: ['id,user,collection.id,collection.name,edit,view,delete,all'],
        filters: { user: { _eq: id } },
        sort: 'collection.name',
      });
      // item.collection can come back null when the logged-in user's role isn't permitted
      // to read that collections item (Directus nulls out unreadable relations rather than
      // throwing) — skip those rows instead of crashing on item.collection.name.
      data = data
        .filter(item => !!item.collection)
        .map(item => {
          return {
            user: item.user,
            view: item.view,
            edit: item.edit,
            delete: item.delete,
            all: item.all,
            id: item.id,
            name: item.collection.name,
          };
        });
      setpermissionData(data);
      setCollPermissions(data);
    } catch (error) {
      console.log(error);
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  let columns = [
    {
      dataIndex: 'name',
      title: 'Collection',
      key: 'name',
      render: (text, record, index) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
    },
    {
      title: 'Read',
      dataIndex: 'view',
      key: 'view',
      render: (text, record, index) => (
        <span>
          <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'view')} checked={!!record.view} />
        </span>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      key: 'edit',
      render: (text, record, index) => (
        <span>
          <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'edit')} checked={!!record.edit} />
        </span>
      ),
    },
    {
      title: 'Delete',
      dataIndex: 'delete',
      key: 'delete',
      render: (text, record) => (
        <span>
          <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'delete')} checked={!!record.delete} />
        </span>
      ),
    },
    {
      title: 'All',
      dataIndex: 'all',
      key: 'all',
      render: (text, record, index) => (
        <span>
          <Checkbox value={record.id} onChange={e => handlePermissions(e, record, 'all')} checked={!!record.all} />
        </span>
      ),
    },
  ];
  const handlePermissions = async (event, record, permission) => {
    setDisabled(false);
    let checked = event.target.checked;
    let permissionObj = managePermissions(permission, checked);
    let newData = collPermissions.map(obj => {
      if (obj.id == record.id) {
        obj = {
          ...obj,
          ...permissionObj,
        };
        // if view, edit, delete checked then "all" checked
        obj.all = obj.view && obj.edit && obj.delete;
      }
      return obj;
    });
    setCollPermissions(newData);
  };

  const managePermissions = (permission, checked) => {
    switch (permission) {
      case 'all':
        return { all: checked, view: checked, edit: checked, delete: checked };
      case 'view':
        return !!checked ? { view: checked } : { view: checked, edit: checked, all: checked, delete: checked };
      case 'edit':
        return !!checked ? { edit: checked, view: checked } : { edit: checked, all: checked };
      case 'delete':
        return !!checked ? { delete: checked, view: checked } : { delete: checked, all: checked };
      default:
        return {};
    }
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      const updateData = collPermissions.filter(item_1 => {
        return !permissionData.some(
          item_2 =>
            item_2.id == item_1.id &&
            item_2.all == item_1.all &&
            item_2.view == item_1.view &&
            item_2.edit == item_1.edit &&
            item_2.delete == item_1.delete
        );
      });
      await props.saveBatchItems('users_permissions', updateData);
      setDisabled(false);
      notification['success']({
        message: 'Collections permissions saved successfully!',
        duration: 2,
      });
    } catch (error) {
      console.log(error);
      notification['error']({
        message: 'Error occurred while saving the record!',
        duration: 2,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading} size="large">
      <div className="artist-list">
        <Table
          className="no-fixed-last-col"
          scroll={{ x: 'max-content' }}
          columns={columns}
          bordered
          rowKey={record => record.id}
          dataSource={collPermissions}
          pagination={false}
          loading={loading}
          components={components}
        />
        <Row gutter={24} className="page-header-section" align="middle" style={{ marginTop: '20px' }}>
          <Col xs={12}>
            <Button
              type="default"
              htmlType="button"
              onClick={() => props.history.push('/users')}
              style={{
                borderColor: '#d9d9d9',
                background: '#f5f5f5',
                color: 'rgba(0, 0, 0, 0.85)',
              }}
            >
              Back
            </Button>

            <Button
              disabled={isDisabled}
              className="save-btn"
              type="primary"
              style={{ margin: '0 8px' }}
              htmlType="button"
              onClick={onFinish}
            >
              Save Permissions
            </Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default CollectionsPermissions;
